import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SecurityProvider } from './context/SecurityContext';
import { initSecurity } from './utils/security';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import AboutPPLTz from './pages/AboutPPLTz';
import ProductsPPLTz from './pages/ProductsPPLTz';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // Initialize security measures
  useEffect(() => {
    initSecurity();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  return (
    <SecurityProvider>
      <Router>
        <ScrollToTop />
        <div className="app">
          <Header currentPage={currentPage} onPageChange={handlePageChange} />
          <main className="main-content">
            <Routes>
              <Route index element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/about-ppl-tz" element={<AboutPPLTz />} />
              <Route path="/products-ppl-tz" element={<ProductsPPLTz />} />
              <Route path="/innovation" element={<Home />} />
              <Route path="/markets" element={<Home />} />
              <Route path="/locations" element={<Home />} />
              <Route path="/careers" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </SecurityProvider>
  );
}

export default App;
